import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
// import { k } from "../../../../../node_modules/@angular/material/module.d-4830783a";

@Component({
  selector: 'app-idle-dialog',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule],
  templateUrl: './idle-dialog.component.html',
  styleUrl: './idle-dialog.component.css'
})
export class IdleDialogComponent {

  private timeRemaining: number;


  constructor(
    public dialogRef: MatDialogRef<IdleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
  }

  stayActive(){
    console.log('user reactivated session');
    this.dialogRef.close();
  }
}
